/* SEKO : messages WhatsApp pre-remplis de la fiche produit (livraison Yango, carte-cadeau).
   Ils reprennent le TEXTE de la case choisie ("38", "50 000 FCFA"), et non sa valeur technique, qui est un identifiant.
   Ce fichier est charge apres les scripts de la fiche : son ecouteur passe en dernier et fixe le lien final. */
(function () {
  var titre = document.querySelector('[data-seko-produit]');
  if (!titre) return;
  var racine = titre.closest('.shopify-section') || document;
  var NUMERO = '2250711466732';

  function etiquette(input) {
    var l = null;
    if (input.id) {
      try { l = document.querySelector('label[for="' + input.id.replace(/"/g, '') + '"]'); } catch (e) {}
    }
    if (!l) { l = input.closest('label') || input.nextElementSibling; }
    return l ? (l.textContent || '').trim() : '';
  }

  function choix() {
    var c = racine.querySelector('.variant-picker input[type="radio"]:checked');
    return c ? etiquette(c) : '';
  }

  function lien(message) { return 'https://wa.me/' + NUMERO + '?text=' + encodeURIComponent(message); }

  var yango = racine.querySelector('[id^="seko-yango-"]');
  if (yango) {
    yango.addEventListener('click', function () {
      var nom = titre.getAttribute('title') || (titre.textContent || '').trim();
      var p = choix();
      yango.href = lien('Bonjour, ' + nom + ' m’intéresse' + (p ? ' en pointure ' + p : '') + '. Je souhaite une livraison Yango.');
    });
  }

  var carte = racine.querySelector('[id^="seko-carte-"]');
  if (carte) {
    carte.addEventListener('click', function () {
      var montant = choix();
      carte.href = lien('Bonjour, je souhaite offrir une carte-cadeau SEKO' + (montant ? ' de ' + montant : '') + '.');
    });
  }
})();
